// @flow

export function addToCartDocumentation (customerId: string, subscriberId: string, productId: string): Promise<any> {
  return window.addProduct(productId, 1)
}
